import React from 'react'
import fileDownload from 'js-file-download'
import { Pipeline, TriggerPipelineOnClick, CallbackOnPipe } from '@morningtrain/react-pipelines'
import { useValue } from '@morningtrain/react-resources'
import Axios from 'axios'

export default function DownloadFile ({
  name,
  defaultValue,
  filenameAttribute = 'filename',
  children
}) {
  const value = useValue(name, defaultValue)
  const filename = useValue(filenameAttribute)

  const handleDownload = React.useCallback(() => {
    Axios.get(value, { responseType: 'blob' }).then(res => {
      fileDownload(res.data, filename)
    })
  }, [value])

  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        {children}
      </TriggerPipelineOnClick>
      <CallbackOnPipe callback={handleDownload} />
    </Pipeline>
  )
}
